import BasicButton from "@components/button/BasicButton";
import Image from "@components/item/Image";
import useUserInfoStore from "@store/useUserInfoStore";
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";

interface SubscriptionButtonProps {
  height?: string;
  width?: string;
  title: string;
  icon?: string;
}

const TossBillingButton: React.FC<SubscriptionButtonProps> = ({
  height = "4.8rem",
  width = "100%",
  title,
  icon,
}) => {
  const { userInfo } = useUserInfoStore();
  const clientKey = process.env.REACT_APP_TOSS_BILLING_CLIENTKEY as string;

  const handleClick = async () => {
    try {
      // 객체 초기화
      const tossPayments = await loadTossPayments(clientKey);

      // 결제 위젯 표시 및 키 발급 요청
      const payment = tossPayments.payment({
        customerKey: userInfo?.toss_customer_key || "",
      });

      // 카드 등록 위젯
      await payment.requestBillingAuth({
        method: "CARD",
        successUrl: `${window.location.origin}/subscribe-success`,
        failUrl: `${window.location.origin}/subscribe-fail`,
      });
    } catch (error) {
      console.error("Billing auth request failed:", error);
    }
  };

  const getButtonProps = () => {
    if (title === "월 5,500원 구독하기") {
      return {
        title: "월 5,500원 구독하기",
        onClick: handleClick,
        point: true,
      };
    } else {
      return {
        title: title,
        onClick: handleClick,
        point: false,
      };
    }
  };

  const buttonProps = getButtonProps();

  return (
    <BasicButton {...buttonProps} height={height} width={width}>
      {icon && (
        <div>
          <Image src={icon} width="1.6rem" height="1.6rem" />
        </div>
      )}
    </BasicButton>
  );
};

export default TossBillingButton;
